import { render } from "./Com_EditSliderList.vue?vue&type=template&id=70895596"
import script from "./Com_EditSliderList.vue?vue&type=script&lang=js"
export * from "./Com_EditSliderList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__